// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
// getUsersInfotools, getUserInfotools, addUserInfotools, updateUserInfotools, deleteUserInfotools
import {
    getUsersInfotools as listUsersInfotoolsAPI,
    getUserInfotools as getUserInfotoolsAPI,
    addUserInfotools as addUserInfotoolsAPI,
    updateUserInfotools as updateUserInfotoolsAPI,
    deleteUserInfotools as deleteUserInfotoolsAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { userInfotoolsApiResponseError, userInfotoolsApiResponseSuccess } from './actions';
import { UserInfotoolsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getUserInfotools({ payload: { id } }) {
    try {
        const response = yield call(getUserInfotoolsAPI, id );
        const userInfotoolsItem = response.data.data;
        yield put(userInfotoolsApiResponseSuccess(UserInfotoolsActionTypes.GET_USER_INFOTOOLS, userInfotoolsItem));
    } catch (error) {
        yield put(userInfotoolsApiResponseError(UserInfotoolsActionTypes.GET_USER_INFOTOOLS, error));
    }
}

function* addUserInfotools({payload:userInfotools}){
    try{
        const response = yield call(addUserInfotoolsAPI,{...userInfotools})
        const userInfotoolsItem = response.data
        yield put(userInfotoolsApiResponseSuccess(UserInfotoolsActionTypes.ADD_USER_INFOTOOLS,userInfotoolsItem))
    } catch(error){
        yield put(userInfotoolsApiResponseError(UserInfotoolsActionTypes.ADD_USER_INFOTOOLS,error))
    }
}

function* updateUserInfotools({payload:userInfotools}){
    try{
        const response = yield call(updateUserInfotoolsAPI,{...userInfotools})
        const userInfotoolsItem = response.data.data
        yield put(userInfotoolsApiResponseSuccess(UserInfotoolsActionTypes.UPDATE_USER_INFOTOOLS,userInfotoolsItem))
    }catch(error){
        yield put(userInfotoolsApiResponseError(UserInfotoolsActionTypes.UPDATE_USER_INFOTOOLS,error))
    }
}
function* deleteUserInfotools({payload:{id}}){
    try{
        const response = yield call(deleteUserInfotoolsAPI,id)
        const userInfotoolsItem = response.data.id
        yield put(userInfotoolsApiResponseSuccess(UserInfotoolsActionTypes.DELETE_USER_INFOTOOLS,userInfotoolsItem))
    }catch(error){
        yield put(userInfotoolsApiResponseError(UserInfotoolsActionTypes.DELETE_USER_INFOTOOLS,error))
    }
}

/**
 * List contactos
 */
function* listUsersInfotools({payload:params}) {
    try {
        const response = yield call(listUsersInfotoolsAPI, { ...params });
        const listaUsersInfotools = response.data.data;
        yield put(userInfotoolsApiResponseSuccess(UserInfotoolsActionTypes.LIST_USERS_INFOTOOLS, listaUsersInfotools));
    } catch (error) {
        yield put(userInfotoolsApiResponseError(UserInfotoolsActionTypes.LIST_USERS_INFOTOOLS, error));
    }
}


export function* watchGetUserInfotools(): any {
    yield takeEvery(UserInfotoolsActionTypes.GET_USER_INFOTOOLS, getUserInfotools);
}

export function* watchListUsersInfotools(): any {
    yield takeEvery(UserInfotoolsActionTypes.LIST_USERS_INFOTOOLS, listUsersInfotools);
}

export function* watchAddUserInfotools():any{
    yield takeEvery(UserInfotoolsActionTypes.ADD_USER_INFOTOOLS,addUserInfotools)
}
export function* watchUpdateUserInfotools():any{
    yield takeEvery(UserInfotoolsActionTypes.UPDATE_USER_INFOTOOLS,updateUserInfotools)
}
export function* watchDeleteUserInfotools():any{
    yield takeEvery(UserInfotoolsActionTypes.DELETE_USER_INFOTOOLS,deleteUserInfotools)
}


function* userInfotoolsSaga(): any {
    yield all([
        fork(watchGetUserInfotools),
        fork(watchListUsersInfotools),
        fork(watchAddUserInfotools),
        fork(watchUpdateUserInfotools),
        fork(watchDeleteUserInfotools),
    ]);
}

export default userInfotoolsSaga;
